import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pay-invoice',
  templateUrl: './pay-invoice.component.html',
  styleUrls: ['./pay-invoice.component.css']
})
export class PayInvoiceComponent implements OnInit {
  public createInvoice: any={};
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/pay-invoice/pay-invoice.component.ts